import type { Language, LanguageIsoCode } from './types';

/**
 * Language reference set, ISO 639-1. Curated to the languages spoken in the
 * countries the suite serves; expand as additional country defaults need
 * them. `nativeName` is the endonym so dropdowns can show both forms.
 */
export const LANGUAGES: readonly Language[] = [
  { isoCode: 'en', name: 'English', nativeName: 'English' },
  { isoCode: 'es', name: 'Spanish', nativeName: 'Español' },
  { isoCode: 'fr', name: 'French', nativeName: 'Français' },
  { isoCode: 'de', name: 'German', nativeName: 'Deutsch' },
  { isoCode: 'it', name: 'Italian', nativeName: 'Italiano' },
  { isoCode: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { isoCode: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
  { isoCode: 'sv', name: 'Swedish', nativeName: 'Svenska' },
  { isoCode: 'no', name: 'Norwegian', nativeName: 'Norsk' },
  { isoCode: 'da', name: 'Danish', nativeName: 'Dansk' },
  { isoCode: 'fi', name: 'Finnish', nativeName: 'Suomi' },
  { isoCode: 'is', name: 'Icelandic', nativeName: 'Íslenska' },
  { isoCode: 'pl', name: 'Polish', nativeName: 'Polski' },
  { isoCode: 'cs', name: 'Czech', nativeName: 'Čeština' },
  { isoCode: 'hu', name: 'Hungarian', nativeName: 'Magyar' },
  { isoCode: 'ro', name: 'Romanian', nativeName: 'Română' },
  { isoCode: 'el', name: 'Greek', nativeName: 'Ελληνικά' },
  { isoCode: 'ru', name: 'Russian', nativeName: 'Русский' },
  { isoCode: 'uk', name: 'Ukrainian', nativeName: 'Українська' },
  { isoCode: 'tr', name: 'Turkish', nativeName: 'Türkçe' },
  { isoCode: 'he', name: 'Hebrew', nativeName: 'עברית' },
  { isoCode: 'ar', name: 'Arabic', nativeName: 'العربية' },
  { isoCode: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
  { isoCode: 'zh', name: 'Chinese', nativeName: '中文' },
  { isoCode: 'ja', name: 'Japanese', nativeName: '日本語' },
  { isoCode: 'ko', name: 'Korean', nativeName: '한국어' },
  { isoCode: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { isoCode: 'th', name: 'Thai', nativeName: 'ไทย' },
  { isoCode: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  { isoCode: 'ms', name: 'Malay', nativeName: 'Bahasa Melayu' },
];

const LANGUAGES_BY_CODE: Map<LanguageIsoCode, Language> = new Map(
  LANGUAGES.map((l) => [l.isoCode, l]),
);

/** Look up a language by ISO code. Returns `undefined` for unknown codes. */
export function findLanguage(isoCode: LanguageIsoCode): Language | undefined {
  return LANGUAGES_BY_CODE.get(isoCode);
}
